import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  CampaignGroups: null,
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,
};
export const fetchCampaignGroups = createAsyncThunk("/CampaignGroups", async () => {
  const response = await axiosInstance.get(`/CampaignGroups`);
  return response.data;
});

const CampaignGroupsSlice = createSlice({
  name: "CampaignGroups",
  initialState,
  reducers: {
    CampaignGroupsAdded: {
      reducer(state, action) {
        state.CampaignGroups?.push(action.payload?.CampaignGroups?.data?.Data);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchCampaignGroups.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCampaignGroups.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload?.Message;
        state.isSuccess = action.payload?.IsSuccess;
        state.CampaignGroups = action.payload?.Data;
      })
      .addCase(fetchCampaignGroups.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});
export const getCampaignGroupsDetails = (state) => state.CampaignGroups;

export const { CampaignGroupsAdded } = CampaignGroupsSlice.actions;

export default CampaignGroupsSlice.reducer;
